import DatePicker from "./DatePicker";
import "./styles/Header.css";

function Header() {
  return (
    <div className="header">
      <div className="left">
        <h3 className="title">Katie's Thought Cabinet</h3>
      </div>
      <div className="date-wrapper">
        <DatePicker />
      </div>
    </div>
  );
}

export default Header;
